import { ContactLinkTypes } from "@/types/enums";

export const formatContactUrl = (
  contactLinkType: ContactLinkTypes,
  url: string,
) => {
  if (contactLinkType === ContactLinkTypes.Email) {
    return url.startsWith("mailto:") ? url : `mailto:${url}`;
  }
  if (contactLinkType === ContactLinkTypes.Phone) {
    return url.startsWith("tel:") ? url : `tel:${url}`;
  }
  return url;
};
